import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

export const useFetchTableData = ({ apiField, limit, sort, currentValue, search, currentPage }) => {
  const [data, setData] = useState([]);
  const [pages, setPages] = useState(0);
  const [totalEnteries, setTotalEnteries] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const dateFieldsToFormat = ["createddate", "issuedate", "podate", "Mstagesdate"];

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${search}`;
        const response = await axios.get(url, {
          headers: authHeader()
        });

        const rawData = response.data.Index || response.data.data;

        const formattedData = rawData.map((item) => {
          const formattedItem = { ...item };
          dateFieldsToFormat.forEach((field) => {
            if (formattedItem[field]) {
              formattedItem[field] = formatDate(formattedItem[field]);
            }
          });
          return formattedItem;
        });

        setData(formattedData);
        setPages(response.data.Pages);
        setTotalEnteries(response.data.Enteries);
      } catch (error) {
        console.error("Error fetching table data:", error);
      }
    };

    fetchData();
  }, [apiField, limit, sort, currentValue, search, currentPage, refreshTrigger]);

  const refetch = () => {
    setRefreshTrigger(prev => !prev);
  };

  return { data, pages, totalEnteries,refetch };
};
